import { render, staticRenderFns } from "./WarningModal.vue?vue&type=template&id=53e3da85"
import script from "./WarningModal.vue?vue&type=script&lang=js"
export * from "./WarningModal.vue?vue&type=script&lang=js"
import style0 from "./WarningModal.vue?vue&type=style&index=0&id=53e3da85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports